<template>
  <div class="main_box">
    <div v-if="list.length > 0" class="main">
      <table class="content_table">
        <thead>
          <tr>
            <th class="th1">序号</th>
            <th class="th2">条目题名</th>
            <th>页码</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in list" :key="index">
            <td class="td1">
              {{ utils.getNewIndex(index, contentPage, contentSize) }}
            </td>
            <td
              class="td2"
              v-if="
                (item.nameC === null || item.nameC === '') &&
                  (item.nameB === null || item.nameB === '')
              "
            >
              <div class="to_pdf" @click="toPdf(item.url)">
                {{ item.nameA }}
              </div>
            </td>
            <td
              class="td2"
              v-else-if="item.nameC === null || item.nameC === ''"
            >
              <div class="to_pdf" @click="toPdf(item.url)">
                {{ item.nameB }}
              </div>
            </td>
            <td class="td2" v-else>
              <div class="to_pdf" @click="toPdf(item.url)">
                {{ item.nameC }}
              </div>
            </td>
            <td class="td3">
              <span>{{ item.pageNumber }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <el-pagination
        background
        small
        :hide-on-single-page="true"
        @current-change="handleSizeChange"
        :current-page="contentPage"
        :page-size="contentSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-else class="no_data">
      <img src="@/assets/img/common/no_data.svg" alt="" />
      <p>
        没有找到相关的内容
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentPage: 1, //当前内容页数
      contentSize: 20, //每页显示多少条
      total: 50, //总数
      list: [],
      id: '',
      keyword: ''
    }
  },
  mounted() {
    this.keyword = this.$route.query.keyword
    this.id = this.$route.query.id
    this.getSearch()
  },
  watch: {
    '$route.query'(newVal, oldVal) {
      this.keyword = newVal.keyword
      this.getSearch()
    }
  },
  methods: {
    // 搜索
    async getSearch() {
      const res = await this.$http('/api/home/industryAnnals/search', {
        params: {
          industryAnnals: this.id,
          blurry: this.keyword,
          page: this.contentPage - 1,
          size: this.contentSize
        }
      })
      this.list = res.content
      this.total = res.totalElements
    },
    // 内容分页
    handleSizeChange(page) {
      this.contentPage = page
      this.getSearch()
    },
    // 跳转PDF
    toPdf(url) {
      window.open('/pdf/web/viewer.html?file=' + encodeURIComponent(url))
    }
  }
}
</script>

<style lang="less" scoped>
.main_box {
  padding: 0 30px;
  animation-duration: 0.4s;
}
.main {
  width: 100%;
  .content_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    tbody {
      tr {
        &:nth-child(2n + 1) {
          background: #dfe3e8;
        }
      }
    }
    span {
      display: inline-block;
    }
    th {
      height: 40px;
      font-size: 16px;
      font-weight: 600;
      box-sizing: border-box;
      text-align: left;
      color: #999;
      font-size: 14px;
    }
    td {
      height: 40px;
      color: #333333;
      font-size: 14px;
      box-sizing: border-box;
      // text-align: center;
      // padding: 0 10px;
      .to_pdf {
        color: #333333;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        cursor: pointer;
        &:hover {
          color: @theme;
          text-decoration: underline;
        }
      }
    }
    .th1 {
      text-align: center;
    }
    .th2 {
      padding-left: 10px;
    }
    .td1 {
      width: 60px;
      text-align: center;
    }
    .td2 {
      padding-left: 10px;
      padding-right: 50px;
    }

    .td3 {
      width: 80px;
      span {
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
